import { render, staticRenderFns } from "./StyledIcon.vue?vue&type=template&id=29b19ae2"
import script from "./StyledIcon.vue?vue&type=script&lang=js"
export * from "./StyledIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports